export const isNonEmptyValue = (value: any): boolean => {
  return (
    value !== null &&
    value !== undefined &&
    value !== '' &&
    value !== 0 &&
    (typeof value === 'number' ? !isNaN(value) : true) &&
    (Array.isArray(value) ? value.filter(isNonEmptyValue).length > 0 : true) &&
    (typeof value === 'object' ? Object.values(value).filter(isNonEmptyValue).length > 0 : true)
  )
}

export const removeEmptyProperties = <T>(
  object: T,
  additionalFilter: (val: unknown) => boolean = () => true,
): Partial<NonNullable<T>> =>
  Object.fromEntries(
    Object.entries(object).filter(([_, value]) => isNonEmptyValue(value) && additionalFilter(value)),
  ) as Partial<NonNullable<T>>
